// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range-row {
  font-size: 20px;
  margin-top: 10px;
  border-bottom: 1px solid #dedede;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/edto/edto.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;AACF","sourcesContent":[".range-row {\n  font-size: 20px;\n  margin-top: 10px;\n  border-bottom: 1px solid #dedede;\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
